import { ConfirmationDialog } from 'components';
import { useTranslation } from 'libs/i18n';
import { Button, DialogStateProps, Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

interface Props extends DialogStateProps {
  onClickPerson: () => void;
  onClickLegal: () => void;
}

export const HeadAddDialog = ({
  isOpen,
  onClose,
  onClickPerson,
  onClickLegal,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      fullWidth
      headerCentered
      hideButtonConfirm
      isOpen={isOpen}
      maxWidth="sm"
      title={t('client.legal.companyHeads.addDialog.title')}
      onBack={onClose}
    >
      <Stack spacing={12}>
        <Button
          fullWidth
          spaceBetween
          colorVariant="gray"
          endIcon={<Icon.ChevronRight />}
          label={t('client.legal.companyHeads.addDialog.person')}
          mode="outlined"
          sizeVariant="l"
          onClick={onClickPerson}
        />

        <Button
          fullWidth
          spaceBetween
          colorVariant="gray"
          endIcon={<Icon.ChevronRight />}
          label={t('client.legal.companyHeads.addDialog.legal')}
          mode="outlined"
          sizeVariant="l"
          onClick={onClickLegal}
        />
      </Stack>
    </ConfirmationDialog>
  );
};
